webpackJsonp([6],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Drawer_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Drawer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Drawer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fab_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Footer_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_Header_vue___default.a,
    'app-drawer': __WEBPACK_IMPORTED_MODULE_1__components_Drawer_vue___default.a,
    'app-fab': __WEBPACK_IMPORTED_MODULE_2__components_Fab_vue___default.a,
    'app-footer': __WEBPACK_IMPORTED_MODULE_3__components_Footer_vue___default.a
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      startX: 0,
      currentX: 0,
      touchingDrawer: false,
      noPanelTransition: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    isDrawerActive: 'isDrawerActive'
  }),
  methods: {
    hideDrawer: function hideDrawer() {
      this.$store.commit('hideDrawer');
    },
    onTouchstart: function onTouchstart(event) {
      this.touchingDrawer = true;
      this.startX = event.touches[0].pageX;
      this.currentX = this.startX;
      this.noPanelTransition = true;
      window.requestAnimationFrame(this.update);
    },
    onTouchMove: function onTouchMove(event) {
      if (!this.touchingDrawer) return;
      this.currentX = event.touches[0].pageX;
    },
    onTouchEnd: function onTouchEnd(event) {
      if (!this.touchingDrawer) return;
      this.touchingDrawer = false;
      this.noPanelTransition = false;
      var translateX = Math.min(0, this.currentX - this.startX);
      this.$refs.drawerPanel.style.transform = '';
      this.$refs.drawerContainer.style.backgroundColor = '';
      if (translateX < 0) {
        this.hideDrawer();
      }
    },
    update: function update() {
      if (!this.touchingDrawer) return;
      window.requestAnimationFrame(this.update);
      var translateX = Math.min(0, this.currentX - this.startX);
      this.$refs.drawerPanel.style.transform = 'translateX(' + translateX + 'px)';
      var panelWidth = Number(window.getComputedStyle(this.$refs.drawerPanel).getPropertyValue('width').slice(0, -2));
      var currentWidth = panelWidth + translateX;
      var opacityRatio = currentWidth / panelWidth;
      var opacityX = 0.6 * opacityRatio;
      this.$refs.drawerContainer.style.backgroundColor = 'rgba(0,0,0,' + opacityX + ')';
    }
  }
});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    showModal: function showModal() {
      this.$router.push({ path: '/contact' });
    }
  }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VFooter__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VBtn__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    VFooter: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VFooter___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VBtn___default.a
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    isHome: function isHome() {
      return this.$route.name === 'Home';
    }
  },
  methods: {
    showDrawer: function showDrawer() {
      //        console.log(this.$store.state.isDrawerActive)
      this.$store.commit('showDrawer');
    },
    goBack: function goBack() {
      this.$router.back();
      this.$store.commit('hidePdf');
    }
  }
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_siema__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_siema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_siema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IntroVideo_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IntroVideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__IntroVideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pdf_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pdf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pdf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imgObjA: {
        src: '../../static/img/home_a.jpg',
        error: '',
        loading: '../../static/img/preload.jpg'
      },
      imgObjB: {
        src: '../../static/img/home_b.jpg',
        error: '',
        loading: '../../static/img/preload.jpg'
      },
      imgObjC: {
        src: '../../static/img/home_c.jpg',
        error: '',
        loading: '../../static/img/preload.jpg'
      },
      activeDotA: true,
      activeDotB: false,
      activeDotC: false,
      // src: loadingTask,
      numPages: undefined,
      gImages: [{
        url: '../../static/img/gallery/wood1.jpg',
        type: 'Decking'
      }, {
        url: '../../static/img/gallery/wood2.jpg',
        type: 'Cladding'
      }, {
        url: '../../static/img/gallery/wood3.jpg',
        type: 'Flooring'
      }, {
        url: '../../static/img/gallery/wood4.jpg',
        type: 'Panelling'
      }],
      gIndex: null,
      dImages: ['../../static/img/cuts/cut1.png', '../../static/img/cuts/cut2.png', '../../static/img/cuts/cut3.png', '../../static/img/cuts/cut4.png', '../../static/img/cuts/cut5.png'],
      dIndex: null
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    isPdfActive: 'isPdfActive'
  }),
  methods: {
    showvideo: function showvideo() {
      this.$refs.introvideo.show();
      this.$refs.introvideo.play();
    },
    onDot: function onDot(index) {
      switch (index) {
        case 0:
          this.activeDotA = true;
          this.activeDotB = false;
          this.activeDotC = false;
          break;
        case 1:
          this.activeDotA = false;
          this.activeDotB = true;
          this.activeDotC = false;
          break;
        case 2:
          this.activeDotA = false;
          this.activeDotB = false;
          this.activeDotC = true;
          break;
        default:
          this.activeDotA = true;
          this.activeDotB = false;
          this.activeDotC = false;
      }
    },
    showPdf: function showPdf() {
      this.$store.commit('showPdf');
    }
  },
  mounted: function mounted() {
    var _this = this;

    var comp = this;
    /* eslint-disable no-new */
    var siema = new __WEBPACK_IMPORTED_MODULE_0_siema___default.a({
      duration: 300,
      onChange: function onChange() {
        comp.onDot(this.currentSlide);
      }
    });
    this.goToSlide = function (index) {
      siema.goTo(index);
      _this.onDot(index);
    };
  },
  components: {
    'intro-video': __WEBPACK_IMPORTED_MODULE_1__IntroVideo_vue___default.a,
    'pdf-swipe': __WEBPACK_IMPORTED_MODULE_2__Pdf_vue___default.a,
    VueGallery: __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showVideo: false
    };
  },

  components: {},
  methods: {
    show: function show() {
      this.showVideo = true;
    },
    play: function play() {
      this.$refs.vid.play();
    },
    stop: function stop() {
      this.$refs.vid.pause();
      this.$refs.vid.currentTime = 0;
      this.showVideo = false;
    }
  }
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        modifierClass: 'swiper-pagination-fraction'
      }
    };
  },

  methods: {
    close: function close() {
      this.$store.commit('hidePdf');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    isPdfActive: 'isPdfActive'
  })
});

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-288abdb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(259),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-321405d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(263),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63ee1562",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(268),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5bf0d58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b1c1b34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f7347b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(260),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48693e3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(262),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(256),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(266),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(265),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      active: _vm.showVideo
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('video', {
    ref: "vid",
    staticClass: "intro",
    attrs: {
      "preload": "none",
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-ap-southeast-2.amazonaws.com/siberianlarchwood/bg.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "svg-btn",
    on: {
      "click": _vm.stop
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "drawerContainer",
    staticClass: "drawer-container",
    class: {
      'drawer-container-active': _vm.isDrawerActive
    },
    on: {
      "click": _vm.hideDrawer,
      "touchstart": function($event) {
        _vm.onTouchstart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      },
      "touchend": function($event) {
        _vm.onTouchEnd($event)
      }
    }
  }, [_c('div', {
    ref: "drawerPanel",
    staticClass: "drawer-panel",
    class: {
      'drawer-panel-active': _vm.isDrawerActive, 'drawer-panel-no-transition': _vm.noPanelTransition
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        _vm.onTouchstart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      },
      "touchend": function($event) {
        _vm.onTouchEnd($event)
      }
    }
  }, [_c('div', {
    staticClass: "drawer-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Home")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("About Us")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M16,18H7V4H16M11.5,22A1.5,1.5 0 0,1 10,20.5A1.5,1.5 0 0,1 11.5,19A1.5,1.5 0 0,1 13,20.5A1.5,1.5 0 0,1 11.5,22M15.5,1H7.5A2.5,2.5 0 0,0 5,3.5V20.5A2.5,2.5 0 0,0 7.5,23H15.5A2.5,2.5 0 0,0 18,20.5V3.5A2.5,2.5 0 0,0 15.5,1Z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Contact Us")])])])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "fab-btn",
    on: {
      "click": _vm.showModal
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29"
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-box",
    class: {
      'hide': !_vm.isPdfActive
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-a.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-a.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-b.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-b.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-c.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-c.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-d.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-d.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-e.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-e.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-f.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-f.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-g.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-g.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-h.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-h.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('intro-video', {
    ref: "introvideo"
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    staticClass: "siema"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imgObjA),
      expression: "imgObjA",
      arg: "background-image"
    }],
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "slide-a"
  }, [_c('h1', {
    staticClass: "slide-header"
  }, [_vm._v("Certified High Quality Siberian Larch")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    ref: "viewbtn",
    staticClass: "play-btn",
    on: {
      "click": _vm.showvideo
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8,5.14V19.14L19,12.14L8,5.14Z"
    }
  })])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('button', {
    staticClass: "learn-more-btn",
    on: {
      "click": _vm.showPdf
    }
  }, [_vm._v("\n              Get A Quote\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imgObjB),
      expression: "imgObjB",
      arg: "background-image"
    }],
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "slide-a"
  }, [_c('div', {
    staticClass: "slide-header"
  }, [_vm._v("Directly from Siberia")]), _vm._v(" "), _c('div', {
    staticClass: "slide-sub-header"
  }, [_vm._v("We source only old growth and slow grown logs from certain regions in central Siberia")]), _vm._v(" "), _c('button', {
    ref: "viewbtn",
    staticClass: "play-btn",
    on: {
      "click": _vm.showvideo
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8,5.14V19.14L19,12.14L8,5.14Z"
    }
  })])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('button', {
    staticClass: "learn-more-btn",
    on: {
      "click": _vm.showPdf
    }
  }, [_vm._v("\n              Get A Quote\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imgObjC),
      expression: "imgObjC",
      arg: "background-image"
    }],
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "slide-a"
  }, [_c('div', {
    staticClass: "slide-header"
  }, [_vm._v("At a price without middlemen")]), _vm._v(" "), _c('div', {
    staticClass: "slide-sub-header"
  }, [_vm._v("You will be dealing with suppliers directly so our prices are competitive.")]), _vm._v(" "), _c('button', {
    ref: "viewbtn",
    staticClass: "play-btn",
    on: {
      "click": _vm.showvideo
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8,5.14V19.14L19,12.14L8,5.14Z"
    }
  })])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('button', {
    staticClass: "learn-more-btn",
    on: {
      "click": _vm.showPdf
    }
  }, [_vm._v("\n              Get A Quote\n            ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dots"
  }, [_c('div', {
    staticClass: "dot",
    class: {
      dotactive: _vm.activeDotA
    },
    on: {
      "click": function($event) {
        _vm.goToSlide(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dot",
    class: {
      dotactive: _vm.activeDotB
    },
    on: {
      "click": function($event) {
        _vm.goToSlide(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dot",
    class: {
      dotactive: _vm.activeDotC
    },
    on: {
      "click": function($event) {
        _vm.goToSlide(2)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "gallery-section"
  }, _vm._l((_vm.gImages), function(image, imageIndex) {
    return _c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: ({
          src: image.url,
          error: '',
          loading: '../../static/img/preload.jpg'
        }),
        expression: "{\n        src: image.url,\n        error: '',\n        loading: '../../static/img/preload.jpg'\n      }",
        arg: "background-image"
      }],
      key: imageIndex,
      staticClass: "image-card",
      on: {
        "click": function($event) {
          _vm.gIndex = imageIndex
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/gallery"
      }
    }, [_c('div', {
      staticClass: "image-text-area"
    }, [_c('h4', [_vm._v(_vm._s(image.type))])])])], 1)
  })), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://s3-ap-southeast-2.amazonaws.com/siberianlarchwood/brochure.pdf",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "title",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_vm._v("\n      View BROCHURES\n      "), _c('svg', {
    staticStyle: {
      "width": "32px",
      "height": "32px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "red",
      "d": "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "products-section"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cards-container"
  }, [_c('div', {
    staticClass: "intro-section"
  }, [_c('div', {
    staticClass: "intro-text"
  }, [_c('p', [_vm._v("SUPREME WOOD PRODUCTS sources only old growth and slow grown logs from certain regions in central Siberia.")]), _vm._v(" "), _c('p', [_vm._v("This golden brown timber with clearly marked annual growth rings and straight grain grows in cold and harsh climate which gives Siberian Larch many fantastic natural attributes")]), _vm._v(" "), _c('p', [_vm._v("Siberian Larch’s high stability, density and versatility makes it desirable in many building projects.")]), _vm._v(" "), _c('div', {
    staticClass: "features"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/versatility.png',
        error: '',
        loading: ''
      }),
      expression: "{\n              src: '../../static/img/versatility.png',\n              error: '',\n              loading: ''\n            }"
    }],
    staticClass: "feature-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "features-point"
  }, [_vm._v("VERSATILITY")]), _vm._v(" "), _c('p', {
    staticClass: "features-point-text"
  }, [_vm._v("Siberian Larch is very dense at 650kg - 700kg per m3 when dried. It is hard wearing and perfect for exposed elevations or high traffic areas. Suitable for both commercial and residential projects, from flooring to facades of houses, decor of interiors, decor of landscape elements.")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/durability.png',
        error: '',
        loading: ''
      }),
      expression: "{\n              src: '../../static/img/durability.png',\n              error: '',\n              loading: ''\n            }"
    }],
    staticClass: "feature-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "features-point"
  }, [_vm._v("DURABILITY")]), _vm._v(" "), _c('p', [_vm._v("Siberian Larch has a maintenance free service life. The presence of resin in the wood creates a high resistance to decay and rot. The high density means that it is more difficult for decaying organisms to penetrate the wood. It makes it one of the toughest and most durable softwoods.")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: ({
        src: 'http://www.steinwoodproducts.com/uploadedimages/Deck%202_1000_1000.jpg',
        error: '',
        loading: ''
      }),
      expression: "{\n              src: 'http://www.steinwoodproducts.com/uploadedimages/Deck%202_1000_1000.jpg',\n              error: '',\n              loading: ''\n        }",
      arg: "background-image"
    }],
    staticClass: "intro-card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("GRADES")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('pdf-swipe')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "whyus-section"
  }, [_c('div', {
    staticClass: "whyus-section-container"
  }, [_c('div', {
    staticClass: "whyus-title"
  }, [_vm._v("Why Us?")]), _vm._v(" "), _c('div', {
    staticClass: "whyus-points-section"
  }, [_c('div', {
    staticClass: "whyus-point"
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,21V16.74C10.53,16.91 10.03,17 9.5,17C7,17 5,15 5,12.5C5,11.23 5.5,10.09 6.36,9.27C6.13,8.73 6,8.13 6,7.5C6,5 8,3 10.5,3C12.06,3 13.44,3.8 14.25,5C14.33,5 14.41,5 14.5,5A5.5,5.5 0 0,1 20,10.5A5.5,5.5 0 0,1 14.5,16C14,16 13.5,15.93 13,15.79V21H11Z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "whyus-point-text"
  }, [_vm._v("\n            competitive price\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "whyus-point"
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "whyus-point-text"
  }, [_vm._v("\n            zero middlemen\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "whyus-point"
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "whyus-point-text"
  }, [_vm._v("\n            high quality woods\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "whyus-text"
  }, [_vm._v("\n        Because the business I run is smaller than the major retailers I can offer cheaper prices because I don't have the overheads of the major retailers.\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-sub-header"
  }, [_vm._v("Building materials in New Zealand is more expensive than most of parts of the world. "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "150%",
      "color": "red"
    }
  }, [_vm._v("Do you want to save up to 70% on your next building project?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-divider"
  }, [_c('span', [_vm._v("Category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-divider"
  }, [_c('span', [_vm._v("SIBERIAN LARCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade-section"
  }, [_c('div', {
    staticClass: "grade-title"
  }, [_vm._v("Grade A+")]), _vm._v(" "), _c('div', {
    staticClass: "grade-text"
  }, [_vm._v("This grade of Siberian Larch is the higher quality available. This is a clear grade timber, providing a clean , aesthetically pleasing and consistent look. Some are virtually knot-free. Excellent durability.")]), _vm._v(" "), _c('div', {
    staticClass: "grade-title"
  }, [_vm._v("Grade A")]), _vm._v(" "), _c('div', {
    staticClass: "grade-text"
  }, [_vm._v("This grade includes a mix of clear grades and allows some larger and a greater amount of knots. It gives a rustic and less uniform look. High level of density and hardness. Excellent durability.")])])
}]}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "height": "auto",
      "dark": ""
    }
  }, [_c('div', {
    staticClass: "footer-container teal darken-2"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Siberian-Larch-1109601115809052/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/siberianlarch_nz",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "links-section"
  }, [_c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/privacy",
      "ripple": false
    }
  }, [_vm._v("\n          Privacy Policy\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/terms",
      "ripple": false
    }
  }, [_vm._v("\n          Terms of service\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/contact",
      "ripple": false
    }
  }, [_vm._v("\n          Contact Us\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-1",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v("\n      Copyright ©2018 — "), _c('strong', [_vm._v("siberianlarchwood.co.nz")]), _vm._v(", All rights reserved.\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('app-header'), _vm._v(" "), _c('app-drawer'), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), _c('app-fab'), _vm._v(" "), _c('app-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-nav-bar"
  }, [_c('div', {
    staticClass: "menu-btn"
  }, [(_vm.isHome) ? _c('button', {
    staticClass: "svg-btn",
    on: {
      "click": _vm.showDrawer
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
    }
  })])]) : _c('button', {
    staticClass: "svg-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-nav-list"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('a', {
    staticClass: "hover-highlight"
  }, [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('a', {
    staticClass: "hover-highlight"
  }, [_vm._v("About Us")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('a', {
    staticClass: "hover-highlight"
  }, [_vm._v("Contacts")])])], 1)])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preload.3d1e926.gif";

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
var _this = this;




var Privacy = function Privacy(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Terms = function Terms(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var About = function About(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Contact = function Contact(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Gallery = function Gallery(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    afterEach: function afterEach(to, next) {
      _this.$store.commit('hidePdf');
    }
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }, {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  }, {
    path: '/terms',
    name: 'Terms',
    component: Terms
  }, {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var appStore = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    isDrawerActive: false,
    isPdfActive: false
  },
  mutations: {
    showDrawer: function showDrawer(state) {
      state.isDrawerActive = true;
    },
    hideDrawer: function hideDrawer(state) {
      state.isDrawerActive = false;
    },
    showPdf: function showPdf(state) {
      state.isPdfActive = true;
    },
    hidePdf: function hidePdf(state) {
      state.isPdfActive = false;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (appStore);

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_youtube_embed__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_src_stylus_app_styl__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// Helpers


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuetify___default.a, {
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default.a.teal.darken2
  }
});





// require styles


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_youtube_embed___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCbRlMCy90GFLf2padG4GdseMkiUABLWCA',
    libraries: 'places'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })

},[99]);


// WEBPACK FOOTER //
// static/js/app.06f7c0d072995477fca1.js